import { Calendar, Download, FileText, UserPlus, UserX, X } from "lucide-react";
const BOOKING_ACTIONS = [
  {
    key: "view",
    label: "View Details",
    icon: FileText,
    visible: () => true,
    className: "hover:bg-gray-100",
  },

  {
    key: "download_invoice",
    label: "Download Invoice",
    icon: Download,
    visible: ({ status }) => status === "completed",
    className: "hover:bg-green-50 text-green-700",
  },

  {
    key: "assign_staff",
    label: "Assign Staff",
    icon: UserPlus,
    visible: ({ status, staffId }) =>
      !staffId && ["verified", "confirmed", "rescheduled"].includes(status),
    className: "hover:bg-blue-50 text-blue-700",
  },

  {
    key: "replace_staff",
    label: "Replace Staff",
    icon: UserX,
    visible: ({ status, staffId }) =>
      !!staffId &&
      ["verified", "confirmed", "assigned", "rescheduled"].includes(status),
    className: "hover:bg-orange-50 text-yellow-600",
  },

  {
    key: "reschedule",
    label: "Reschedule",
    icon: Calendar,
    visible: ({ status }) =>
      ["pending", "payment_verified", "rescheduled", "confirmed"].includes(
        status,
      ),
    className: "hover:bg-gray-100",
  },
  {
    key: "cancel",
    label: "Cancel Booking",
    icon: X,
    visible: ({ status }) =>
      ["pending", "payment_verified", "confirmed", "rescheduled"].includes(
        status,
      ),
    className: "hover:bg-red-50 text-red-600",
  },
];
const BookingActionsMenu = ({ booking, onAction, placement = "bottom" }) => {
  const positionClass = placement === "top" ? "bottom-[60%]" : "top-12";
  return (
    <div
      className={`absolute right-10 w-44 text-xs bg-white rounded-lg shadow-xl border border-gray-200 z-[9999] ${positionClass}`}
    >
      {BOOKING_ACTIONS.filter((action) => action.visible(booking)).map(
        (action) => {
          const Icon = action.icon;

          return (
            <button
              key={action.key}
              onClick={() => onAction(action.key, booking)}
              className={`w-full px-3 py-3 text-left flex items-center gap-2 ${action.className}`}
            >
              <Icon size={15} />
              {action.label}
            </button>
          );
        },
      )}
    </div>
  );
};

export default BookingActionsMenu;
